import { render, staticRenderFns } from "./QuickCounters.vue?vue&type=template&id=4ec2aa28&"
import script from "./QuickCounters.vue?vue&type=script&lang=js&"
export * from "./QuickCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports